import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { toast } from 'react-toastify';

interface InactiveCompanyRestrictionProps {
  children: React.ReactNode;
  allowedPages?: string[];
}

const InactiveCompanyRestriction: React.FC<InactiveCompanyRestrictionProps> = ({ 
  children, 
  allowedPages = ['/reports'] 
}) => {
  const { auth } = useAuth();
  const currentPath = window.location.pathname;

  // Check if user's company is inactive
  const isCompanyInactive = auth.user?.company_is_active === false;

  // If company is inactive and current page is not in allowed pages
  if (isCompanyInactive && !allowedPages.includes(currentPath)) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        padding: '2rem',
        textAlign: 'center',
        backgroundColor: '#f8f9fa'
      }}>
        <div style={{
          backgroundColor: 'white',
          padding: '2rem',
          borderRadius: '12px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          maxWidth: '500px'
        }}>
          <h2 style={{ color: '#dc3545', marginBottom: '1rem' }}>
            ⚠️ Company Account Inactive
          </h2>
          <p style={{ color: '#6c757d', marginBottom: '1.5rem', lineHeight: '1.6' }}>
            Your company account is currently inactive. You can only access the Reports page.
            Please contact your administrator to reactivate your account.
          </p>
          <button
            onClick={() => window.location.href = '/reports'}
            style={{
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              padding: '0.75rem 1.5rem',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: '500'
            }}
          >
            Go to Reports
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default InactiveCompanyRestriction; 